// 首页数据管理文件
// 用于集中管理Home.vue页面的所有数据，从JSON文件动态加载

// 缓存机制：避免重复请求
let cachedHomeData = null;
let cacheTimestamp = 0;
const CACHE_DURATION = 5 * 60 * 1000; // 5分钟缓存

// 获取首页数据
export const getHomeData = async () => {
  // 检查缓存是否有效
  const now = Date.now();
  if (cachedHomeData && (now - cacheTimestamp) < CACHE_DURATION) {
    return cachedHomeData;
  }

  try {
    // 从JSON文件获取数据
    const response = await fetch('/data/home.json');
    if (!response.ok) {
      throw new Error('Failed to fetch home data');
    }
    
    const data = await response.json();
    
    // 更新缓存
    cachedHomeData = data;
    cacheTimestamp = now;
    
    return data;
  } catch (error) {
    console.error('Error fetching home data:', error);
    // 返回默认数据，确保应用正常运行
    return {
      featuredProducts: [],
      canvasBags: [],
      equipments: [],
      communityPhotos: [],
      communityStats: {
        totalDistance: "0 公里",
        activeMembers: "0",
        completedRoutes: "0"
      },
      racingCars: []
    };
  }
};

// 导出独立的数据获取函数，保持与原有API兼容
export const featuredProducts = async () => {
  const data = await getHomeData();
  return data.featuredProducts;
};

export const canvasBags = async () => {
  const data = await getHomeData();
  return data.canvasBags;
};

export const equipments = async () => {
  const data = await getHomeData();
  return data.equipments;
};

export const communityPhotos = async () => {
  const data = await getHomeData();
  return data.communityPhotos;
};

export const communityStats = async () => {
  const data = await getHomeData();
  return data.communityStats;
};

export const racingCars = async () => {
  const data = await getHomeData();
  return data.racingCars;
};